import { PayloadAction } from '@reduxjs/toolkit';
import { t } from '~/utils/lang';
import { Language, LayoutState, ViewMode } from '.';

const layoutReducer = {
  changeViewMode: (state: LayoutState, action: PayloadAction<keyof typeof ViewMode>) => {
    state.viewMode = action.payload;
  },
  changeLanguage: (state: LayoutState, action: PayloadAction<Language>) => {
    t.setLang(action.payload);

    state.lang = action.payload;
  },
};

export default layoutReducer;
